import { useQuery } from "@apollo/react-hooks";
import { checkRole, getParamByRole, reducerFn } from "../../helper";
import { GET_AMAZON_IDEA_TEMPLATES } from "../../graphql/queries/amazon-idea";
import { AmazonIdeaTemplateProvider } from "./context";
import { get } from "lodash";
import { Button, ButtonGroup, Card, Page } from "@shopify/polaris";
import React from "react";
import { useAppContext } from "../../context";
import AmazonIdeaTemplateFilter from "./amazon-idea-template-filter";
import AmazonIdeaTemplateTable from "./amazon-idea-template-table";

function AmazonIdeaTemplate() {
    const { currentUser } = useAppContext();
    const pathname = getParamByRole(currentUser);

    const { isChannelSupporter, isChannelSupportLeader } =
        checkRole(currentUser);
    const isSupportRole = isChannelSupporter || isChannelSupportLeader;

    return (
        <Page
            fullWidth
            title="Amazon Idea Templates"
            primaryAction={
                !isSupportRole ? (
                    <ButtonGroup>
                        <Button
                            primary
                            url={`/${pathname}/amazon-idea-templates/create`}
                        >
                            Create Amazon Idea Template
                        </Button>
                    </ButtonGroup>
                ) : null
            }
        >
            <Card sectioned>
                <AmazonIdeaTemplateFilter />
            </Card>
            <Card>
                <AmazonIdeaTemplateTable />
            </Card>
        </Page>
    );
}

export default function AmazonIdeaTemplateWrapper() {
    const [filter, setFilter] = React.useReducer(reducerFn, {
        limit: 20,
        offset: 0,
        search: "",
    });

    const { data, loading, error, refetch } = useQuery(
        GET_AMAZON_IDEA_TEMPLATES,
        {
            variables: {
                filter,
            },
            fetchPolicy: "no-cache",
        },
    );

    return (
        <AmazonIdeaTemplateProvider
            filter={filter}
            setFilter={setFilter}
            loading={loading}
            error={error}
            refetch={refetch}
            amazonIdeaTemplates={getAmazonIdeaTemplates(data)}
            total={getTotal(data)}
        >
            <AmazonIdeaTemplate />
        </AmazonIdeaTemplateProvider>
    );
}

function getTotal(data) {
    return get(data, "getAmazonIdeaTemplates.total");
}

function getAmazonIdeaTemplates(data) {
    return get(data, "getAmazonIdeaTemplates.nodes") || [];
}
